import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function WhoThisIsFor() {
  const items = ['Overstimulated (noise, mess, touching, notifications)', 'Behind (even though you never stop moving)', "Guilty (because 'it shouldn't be this hard')", "Stuck (because you can't find time to reset anything)"];
  return <Section background="white" data-id="element-194">
      <div className="text-center mb-12" data-id="element-195">
        <h2 className="text-3xl md:text-4xl font-serif text-[#4A4238] mb-4" data-id="element-196">
          Who this is for
        </h2>
        <p className="text-lg text-[#8C7E6E] max-w-2xl mx-auto" data-id="element-197">
          If you're a postpartum mom with a baby 0–6 months and you feel:
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-198">
        {items.map((item, index) => <div key={index} className="flex items-start p-6 bg-[#FAF7F2] rounded-xl border border-[#E8E0D5]" data-id="element-199">
            <div className="flex-shrink-0 mr-4" data-id="element-200">
              <div className="w-8 h-8 rounded-full bg-[#E8E0D5] flex items-center justify-center text-[#7BA99E]" data-id="element-201">
                <Check size={18} strokeWidth={3} data-id="element-202" />
              </div>
            </div>
            <p className="text-lg text-[#4A4238] font-medium pt-1" data-id="element-203">{item}</p>
          </div>)}
      </div>

      <div className="bg-[#4A4238] text-[#FAF7F2] p-8 md:p-10 rounded-2xl text-center" data-id="element-204">
        <p className="text-xl md:text-2xl font-serif italic leading-relaxed" data-id="element-205">
          "This was built for you. Not for aesthetic routines. Not for perfect
          schedules. Not for the mom who has a village on-call.{' '}
          <span className="text-[#7BA99E] not-italic font-semibold" data-id="element-206">
            For the mom in real life.
          </span>
          "
        </p>
      </div>
    </Section>;
}